module.exports = __webpack_public_path__ + "media/fantasy-world.02979407.mp4";